import handleError from "./handle-error";
import api from "../api";
import axios from "../utils/axios.instance";

export const getReferralMatchedJobs = async (candidateId) => {
  try {
    const { data } = await axios.get(
      api.referralMatchedJobs + `?candidateId=${candidateId}`
    );
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const verifyReferralInvite = async (email) => {
  try {
    const { data } = await axios.get(api.verifyReferralInvite + `/${email}`);

    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const inviteNewReferral = async (params) => {
  try {
    const { referralEmail, invitedBy, referralAlreadyExists } = params;

    const requestBody = {
      invitedBy,
      referralAlreadyExists,
    };

    if (!referralAlreadyExists) {
      // @ts-ignore
      requestBody.referralEmail = referralEmail;
    }

    const { data } = await axios.post(api.inviteReferral, requestBody);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const contactMatchesJob = async () => {
  try {
    const { data } = await axios.get(api.contactMatchesJob);

    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const contactMatchesSkills = async (candidateId, jobId) => {
  try {
    const { data } = await axios.get(
      api.contactMatchesSkills + `/${candidateId}/${jobId}`
    );

    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getReferralTrackers = async (applicationId) => {
  try {
    const { data } = await axios.get(
      `${api.getReferralTrackers}?applicationId=${applicationId}`
    );

    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getReferralByName = async (name) => {
  try {
    const { data } = await axios.get(`/user/get-all-referrals?name=${name}`);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const updateReferralAccountApi = async (payload) => {
  try {
    const { data } = await axios.patch(api.updateReferral, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const referralRequestActionApi = async (payload) => {
  try {
    const { data } = await axios.patch(api.referralRequestAction, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getJobMessagesList = async (jobId, _id) => {
  try {
    const { data } = await axios.get(api.getJobMessagesList + `/${_id}`, {
      params: { jobId },
    });
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const sendJobMessage = async (payload) => {
  try {
    const { data } = await axios.post(api.sendJobMessage, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const getCandidateCertificateOrEducation = async (candidateId) => {
  try {
    const { data } = await axios.get(
      api.getCertificateOrEducation + `?candidateId=${candidateId}`
    );

    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const requestCandidateDetailAccess = async (payload) => {
  try {
    const { data } = await axios.post(api.requestDetailAccess, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};

interface GetReferralRecruitersParams {
  limit?: number
  page?: number
}

export const getReferralRecruiters = async ({ limit = 100, page = 1 }: GetReferralRecruitersParams) => {
  try {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit.toString())
    if (page) params.append('page', page.toString())
    const URL = params ? api.referralRecruiterContacts+'?' + params?.toString() : api.referralRecruiterContacts
    const { data } = await axios.get(URL);
    return data;
  } catch (err) {
    return handleError(err);
  }
};
